// Länder außerhalb der EU (Kunden außerhalb der EU): alle Länder nach ISO 3166-1 (zwei Buchstaben) ohne Deutschland
// und die EU-Länder (laender.ts), dazu Kosovo (XK). Erzeugt beim Laden aus den Länder-Namen des Browsers
// (Intl.DisplayNames, deutsch), nach derselben Regel wie der Server (server/.../rechnungstool/laender-welt.ts); ein Test
// vergleicht beide. Ohne React, damit der Server-Test die Datei lesen kann.
import { EU_LAENDER } from './laender';

// Kürzel mit Namen, die kein Land nach ISO 3166-1 sind (Gebiete mit reserviertem Kürzel, Gruppen, „unbekannt“); dazu
// alle X…, außer Kosovo
const KEIN_LAND = new Set(['AC', 'CP', 'DG', 'EA', 'IC', 'TA', 'EU', 'EZ', 'UN', 'QO', 'ZZ']);

export function weltLaender(): [code: string, name: string][] {
  const eu = new Set(['DE', ...EU_LAENDER.map((l) => l[0])]);
  const liste: [string, string][] = [];
  let namen: Intl.DisplayNames;
  try {
    namen = new Intl.DisplayNames('de', { type: 'region' });
  } catch {
    return liste;
  }
  for (let a = 65; a <= 90; a++) {
    for (let b = 65; b <= 90; b++) {
      const c = String.fromCharCode(a, b);
      if (KEIN_LAND.has(c) || (c[0] === 'X' && c !== 'XK') || eu.has(c)) continue;
      let name: string | undefined;
      try {
        name = namen.of(c);
        if (Intl.getCanonicalLocales(`und-${c}`)[0] !== `und-${c}`) continue;
      } catch {
        continue;
      }
      if (name && name !== c) liste.push([c, name]);
    }
  }
  return liste.sort((x, y) => x[1].localeCompare(y[1], 'de'));
}

export const LAENDER_WELT: [code: string, name: string][] = weltLaender();
const WELT = new Set(LAENDER_WELT.map((l) => l[0]));

// Kunde außerhalb der EU
export const istDrittland = (c: string | null | undefined) => !!c && WELT.has(c);
// Kunde in einem anderen EU-Land
export const istEuAusland = (c: string | null | undefined) => !!c && c !== 'DE' && EU_LAENDER.some((l) => l[0] === c);
// Name des Landes auf Deutsch (unbekannt: das Kürzel)
export const landName = (c: string) =>
  c === 'DE' ? 'Deutschland' : (EU_LAENDER.find((l) => l[0] === c)?.[1] ?? LAENDER_WELT.find((l) => l[0] === c)?.[1] ?? c);
